import React, { useEffect, useState } from "react";
import {
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
  Typography,
  Grid,
  makeStyles,
  FormControl,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import { appUrl } from "../../../../../../utils/config";
import { useDispatch } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import { ChevronRight } from "@material-ui/icons";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../containers/actions/types";
import axios from "axios";
import jwtDecode from "jwt-decode";
import {
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontWeight: 700,
    fontSize: "22px",
    marginBottom: "1.5rem",
    textAlign: "center",
    color: "#000",
  },
  closeButton: {
    fontSize: "1rem",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: "#FF0000",
  },
  customSelect: {
    minWidth: 150,
  },
  customSelectSty: {
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  textField: {
    "& .MuiInputBase-root": {
      lineHeight: "0.6rem",
    },
  },
  commentField: {
    "& .MuiInputBase-input": {
      lineHeight: "1.2rem",
    },
  },
  ribbonHeader: {
    fontWeight: 700,
    fontSize: 13.6,
  },
  ribbonSubHeader: {
    fontSize: 13.6,
    padding: "0px",
  },
  ribbonTableContainer: {
    backgroundColor: "#f2f8fb",
    border: "1px solid #ccc",
    borderRadius: "4px",
    marginTop: "1rem",
    marginBottom: "1rem",
    overflowX: "hidden",
    width: "100%",
    paddingTop: "4px",
    paddingBottom: "2px",
  },
  ribbonTable: {
    backgroundColor: "#f2f8fb",
    "& .MuiTableCell-root": {
      padding: "2px",
    },
  },
}));

const DeleteLotAllocationDialog = ({
  open,
  onClose,
  lotData,
  componentData,
  poData,
  schrockenSLID,
  vendorMosymphonyID,
  lotAllocationRes,
  onSuccess,
  shouldTrackDeletion = false,
  poNumber,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [reasonCodes, setReasonCodes] = useState([]);
  const [selectedReason, setSelectedReason] = useState("");
  const [comment, setComment] = useState("");
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [error, setError] = useState(false);
  

  // useEffect(() => {
  //   const requestObject = {
  //     searchField: "all",
  //     searchValue: "",
  //     reasonCodeGroupType: "all",
  //     reasonCodeType: "all",
  //     status: "all",
  //     collaboratorTypeID: "all",
  //   };
  //   axios
  //     .post(
  //       `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodes`,
  //       requestObject
  //     )
  //     .then((res) => {
  //       if (res.data.status) {
  //         if (res.data.data) {
  //           setReasonCodes(res.data.data.reasonCodeList);
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  // Enable Save button when reason code or comment is provided
  useEffect(() => {
    const hasReasonOrComment =
      (selectedReason.trim() !== "" && selectedReason.trim() !== "EXMRP019") ||
      (selectedReason.trim() === "EXMRP019" && comment.trim() !== "") ||
      (selectedReason.trim() === "" && comment.trim() !== "");
    setIsSaveEnabled(hasReasonOrComment);
  }, [selectedReason, comment]);

  const handleSave = () => {
    if (!isSaveEnabled) return;

    // Find the deleted lot from componentData
    const deletedLotNumber = localStorage.collabType === "CMO" ? lotData?.boLotNumber : lotData?.lotNumber;
    const deletedLotItem = componentData?.lotNumberAllocationDetails?.find((item) => {
      const itemLotNumber = localStorage.collabType === "CMO" ? item?.boLotNumber : item?.lotNumber;
      return itemLotNumber === deletedLotNumber;
    });

    // Create payload to delete the lot allocation
    // Include only the deleted lot's previous allocation with its original quantity
    const previousLotNumberAllocationDetails = deletedLotItem
      ? [
          {
            lotNumber:
              localStorage.collabType === "CMO"
                ? deletedLotItem?.boLotNumber
                : deletedLotItem?.lotNumber,
            plannedAllocatedQuantity:
              localStorage.collabType === "CMO"
                ? deletedLotItem?.boPlannedAllocatedQuantity
                : deletedLotItem.plannedAllocatedQuantity,
          },
        ]
      : [];

    // Create lot allocation with only the deleted lot having quantity 0
    const lotNumberAllocationDetails = deletedLotItem
      ? [
          {
            lotNumber:
              localStorage.collabType === "CMO"
                ? deletedLotItem?.boLotNumber
                : deletedLotItem?.lotNumber,
            plannedAllocatedQuantity: 0,
            allocationDeleted: true,
          },
        ]
      : [];

    // Create Final Payload Object
    const deletePayload = {
      schrockenSLID: schrockenSLID,
      lastUpdatedBy: "",
      senderLegalName: "",
      receiverLegalName: "",
      dateChangeFlag: false,
      cdmoOrgID: vendorMosymphonyID,
      poNumber: poNumber || poData?.scheduleLineDetails?.scheduleAgreementNumber,
      poStatus: poData?.scheduleLineDetails?.scheduleLineStatusText,
      productCodeDiscription: `${poData?.scheduleLineDetails?.fgMaterialCode} / ${poData?.scheduleLineDetails?.fgMaterialName}`,
      bomQty: poData?.scheduleLineDetails?.targetQuantity,
      uom: poData?.scheduleLineDetails?.targetQuantityUOM,
      boProductCode: lotAllocationRes?.boProductCode,
      boProductDescription: lotAllocationRes?.boProductDescription,
      cmoProductCode: lotAllocationRes?.cmoProductCode,
      cmoProductDescription: lotAllocationRes?.cmoProductDescription,
      allocationDeleted: true,
      generateAllocationPDF: false,
      componentAllocationDataList: [
        {
          componentAllocationDetails: {
            componentCode:
              localStorage.collabType === "CMO"
                ? componentData?.componentAllocationDetails?.boComponentCode
                : componentData?.componentAllocationDetails?.componentCode,
            deliveryScheduleLineCounter:
              componentData?.componentAllocationDetails
                ?.deliveryScheduleLineCounter,
            reasonCode: selectedReason,
            comment: comment.trim(),
            boComponentCode:
              componentData?.componentAllocationDetails?.boComponentCode,
            boComponentName:
              componentData?.componentAllocationDetails?.boComponentName,
            cmoComponentCode:
              componentData?.componentAllocationDetails?.cmoComponentCode,
            cmoComponentName:
              componentData?.componentAllocationDetails?.cmoComponentName,
          },
          previousLotNumberAllocationDetails: previousLotNumberAllocationDetails,
          lotNumberAllocationDetails: lotNumberAllocationDetails, // All lots with deleted lot having quantity 0
        },
      ],
    };

    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait....",
    });

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateComponentAllocationNew`,
        deletePayload
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          onSuccess("success");
          onClose();
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          onSuccess("failed");
        }
      })
      .catch((err) => {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        onSuccess("failed");
        // console.log(err);
      });
  };

  const handleClose = () => {
    setSelectedReason("");
    setComment("");
    setError(false);
    onClose();
  };

  return (
    <React.Fragment>
      <DialogContent style={{ overflowX: "hidden" }}>
        <Grid container justifyContent="flex-end">
          <Typography
            variant="body2"
            style={{
              fontSize: "1rem",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={handleClose}
          >
            Cancel <CloseIcon style={{ color: "#FF0000" }} fontSize="large" />
          </Typography>
        </Grid>
        <Typography
          style={{
            fontWeight: "700",
            color: "black",
            fontSize: "22px",
            marginBottom: "0.5rem",
            marginLeft: "1rem",
            marginRight: "1rem",
            textAlign: "center",
          }}
        >
          Deleting batch allocation for PO {" "}
          {poData?.scheduleLineDetails?.scheduleAgreementNumber}
        </Typography>

        {/* <Grid container spacing={3} style={{ marginTop: "1rem" }}>
          <Grid item xs={12}>
            <Typography
              variant="subtitle2"
              style={{ marginBottom: "10px", fontWeight: 700 }}
            >
              Material Code / Description
            </Typography>
            <Typography>
              {presentFormatedData(
                componentData?.componentAllocationDetails?.componentCode,
                "NA"
              )}{" "}
              /{" "}
              {presentFormatedData(
                componentData?.componentAllocationDetails?.componentName,
                "NA"
              )}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="subtitle2"
              style={{ marginBottom: "10px", fontWeight: 700 }}
            >
              Material Batch Number
            </Typography>
            <Typography>
              {lotData?.lotNumber || lotData?.boLotNumber || "NA"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="subtitle2"
              style={{ marginBottom: "10px", fontWeight: 700 }}
            >
              Planned Allocated Qty.
            </Typography>
            <Typography>
              {lotData?.plannedAllocatedQuantity ||
                lotData?.boPlannedAllocatedQuantity ||
                "NA"}
            </Typography>
          </Grid>
        </Grid> */}

        {/* Blue Ribbon */}
        <TableContainer
          component={Paper}
          className={classes.ribbonTableContainer}
        >
          <Table className={classes.ribbonTable} style={{ width: "100%", tableLayout: "auto" }}>
            <TableHead>
              <TableRow style={{ maxHeight: "2rem" }}>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.ribbonHeader}>
                    {localStorage.collabType === "CMO" ? "Sponsor" : "CMO"}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.ribbonHeader}>
                    Plant ID
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.ribbonHeader}>
                    Storage Location ID
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.ribbonHeader}>
                   BMS Material Code / Description
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.ribbonHeader}>
                    Material BOM Qty.
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.ribbonHeader}>UOM</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow
                style={{
                  backgroundColor: "#f2f8fb",
                  border: "none",
                  maxHeight: "2rem",
                }}
              >
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.ribbonSubHeader}>
                    {presentFormatedData(
                      localStorage.collabType === "CMO"
                        ? poData?.scheduleLineDetails?.sponsorName
                        : poData?.scheduleLineDetails?.vendorName,
                      ""
                    )}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.ribbonSubHeader}>
                    {presentFormatedData(
                      poData?.scheduleLineDetails?.vendorPlant,
                      ""
                    )}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography
                    style={{ maxWidth: 250 }}
                    className={classes.ribbonSubHeader}
                  >
                    {presentFormatedData(
                      poData?.scheduleLineDetails?.storageLocation,
                      ""
                    )}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography
                    style={{ maxWidth: 250 }}
                    className={classes.ribbonSubHeader}
                  >
                    {presentFormatedData(
                      componentData?.componentAllocationDetails?.componentCode,
                      ""
                    )}{" "}
                    /{" "}
                    {presentFormatedData(
                      componentData?.componentAllocationDetails?.componentName,
                      ""
                    )}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.ribbonSubHeader}>
                    {componentData?.componentAllocationDetails?.componentQuantity !== undefined &&
                    componentData?.componentAllocationDetails?.componentQuantity !== null
                      ? Number(
                          componentData?.componentAllocationDetails
                            ?.componentQuantity
                        ).toFixed(3)
                      : ""}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.ribbonSubHeader}>
                    {presentFormatedData(
                      componentData?.componentAllocationDetails?.uom,
                      ""
                    )}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* <Grid container spacing={3} style={{ marginTop: "1rem" }}>
          <Grid item xs={4}>
            <Typography
              variant="subtitle2"
              style={{ marginBottom: "10px", fontWeight: 700 }}
            >
              Reason Code / Description{" "}
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <FormControl
              className={classes.customSelect}
              style={{ width: "600px" }}
            >
              <Select
                variant="outlined"
                value={selectedReason}
                onChange={(e) => {
                  setError(false);
                  setSelectedReason(e.target.value);
                }}
                displayEmpty
                className={classes.customSelectSty}
                error={error && selectedReason === ""}
              >
                <MenuItem value="" disabled>
                  Select Reason Code
                </MenuItem>
                {reasonCodes?.map((reason) => (
                  <MenuItem key={reason.reasonCode} value={reason.reasonCode}>
                    {reason.reasonCode} / {reason.reasonDescription || ""}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid> */}

        <Grid container spacing={2} style={{ marginTop: "1rem" }}>
          <Grid item xs={12}>
            <Typography
              variant="subtitle2"
              style={{ marginBottom: "10px", fontWeight: 700 }}
            >
              Comment
              <span style={{ color: "red" }}> *</span>
            </Typography>
            <TextField
              className={`${classes.textField} ${classes.commentField}`}
              fullWidth
              multiline
              rows={4}
              value={comment}
              onChange={(e) => {
                if(e.target.value.length < 256){
                setComment(e.target.value);
                }
              }}
              variant="outlined"
              size="small"
              placeholder="Enter text here"
            />
            {/* <Typography variant="caption" style={{ color: error && "red" }}>
              Note - If reason code is not entered, comment field is mandatory.
            </Typography> */}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions
        style={{
          justifyContent: "center",
          marginBottom: "16px",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          disabled={!isSaveEnabled}
          endIcon={<ChevronRight />}
          style={{
            borderRadius: "20px",
            textTransform: "none",
          }}
          onClick={handleSave}
        >
          Save changes
        </Button>
      </DialogActions>
    </React.Fragment>
  );
};

export default DeleteLotAllocationDialog;

